import {
  ImagesMainBannerApril2025BowmoreSelectionWebp,
  ImagesMainBannerApril2025BottlesOfTheMonthWebp,
} from '@/assets/images_main-banner_april-2025.assets';
import { PrimaryButtonLink } from '@/components/common/PrimaryButton';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { IndexEnum } from '@/types/translations/IndexEnum';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { ImagesMainBannerChristmas2024New } from '@/assets';
export function BowmoreSelectionMainBannerApril2025() {
  const { translate } = useTypedTranslation<IndexEnum>('index');
  return (
    <div className="col-12 tw-relative tw-flex tw-h-[390px] tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-[30px] max-nine:tw-h-[320px] max-nine:tw-rounded-none">
      <div className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center max-nine:tw-px-4 max-nine:tw-backdrop-blur-sm max-nine:tw-backdrop-brightness-50">
        <div className="tw-flex tw-flex-col max-nine:tw-items-center nine:tw-pr-40">
          <h2 className="tw-relative tw-m-0 tw-flex tw-max-w-[500px] tw-flex-col tw-pb-4 tw-text-left tw-font-prata tw-text-4xl tw-leading-[1.3] tw-text-white tw-opacity-90 max-xl:tw-text-4xl max-nine:tw-max-w-[300px] max-nine:tw-text-center max-nine:tw-text-2xl max-nine:tw-leading-[1.2]">
            {translate(IndexEnum['bowmore_selection_april_2025.title'])}
            <hr
              className="tw-absolute tw-bottom-0 tw-m-0 tw-h-1 tw-w-[100%] tw-rounded-full tw-border-t-0 tw-border-none tw-bg-custom-gold tw-p-0 tw-opacity-100"
              aria-hidden="true"
            />
          </h2>
          <div>
            <p className="tw-mb-6 tw-max-w-[500px] tw-pt-4 tw-text-left tw-text-white tw-opacity-90 max-nine:tw-m-auto max-nine:tw-max-w-[280px] max-nine:tw-pb-2 max-nine:tw-text-center max-nine:tw-text-sm">
              {translate(IndexEnum['bowmore_selection_april_2025.text'])}
            </p>
            <PrimaryButtonLink
              href="/brands/Bowmore"
              white={true}
              className="tw-px-12 tw-text-main max-nine:tw-flex max-nine:tw-items-center max-nine:tw-justify-center max-nine:tw-px-6 max-nine:tw-text-sm"
            >
              {translate(IndexEnum['bowmore_selection_april_2025.button'])}
            </PrimaryButtonLink>
          </div>
        </div>
      </div>
      <Image
        src={ImagesMainBannerApril2025BowmoreSelectionWebp}
        priority={true}
        alt="Bowmore Selection"
        className="tw-absolute tw-inset-0 -tw-z-10 tw-h-full tw-w-full tw-rounded-[30px] tw-object-cover"
      />
    </div>
  );
}

export function MacallanBlog() {
  const { t: tMainbanner } = useTranslation('mainbanner');
  const { locale } = useRouter();
  return (
    <div className="col-12 tw-relative tw-flex tw-h-[390px] tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-[30px] max-nine:tw-h-[320px] max-nine:tw-rounded-none">
      <div className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center max-nine:tw-px-4 max-nine:tw-backdrop-blur-sm max-nine:tw-backdrop-brightness-50">
        <div className="tw-flex tw-flex-col max-nine:tw-items-center nine:tw-pr-20">
          <h2 className="tw-relative tw-m-0 tw-flex tw-max-w-[500px] tw-flex-col tw-pb-4 tw-text-left tw-font-prata tw-text-3xl tw-leading-[1.3] tw-text-white tw-opacity-90 max-xl:tw-text-4xl max-nine:tw-max-w-[300px] max-nine:tw-text-center max-nine:tw-text-2xl max-nine:tw-leading-[1.2]">
            {tMainbanner('macallaneblogtitle')}
            <hr
              className="tw-absolute tw-bottom-0 tw-m-0 tw-h-1 tw-w-[100%] tw-rounded-full tw-border-t-0 tw-border-none tw-bg-custom-gold tw-p-0 tw-opacity-100"
              aria-hidden="true"
            />
          </h2>
          <div>
            <p className="tw-mb-6 tw-max-w-[500px] tw-pt-4 tw-text-left tw-text-white tw-opacity-90 max-nine:tw-m-auto max-nine:tw-max-w-[280px] max-nine:tw-pb-2 max-nine:tw-text-center max-nine:tw-text-sm">
              {tMainbanner('macallaneblogtext')}
            </p>
            <PrimaryButtonLink
              href={`/blog/4-exclusive-macallan-editions-you-need-to-know-the-reach-tales-quest-collection-and-1824-decanters-${locale}`}
              white={true}
              className="tw-px-12 tw-text-main max-nine:tw-flex max-nine:tw-items-center max-nine:tw-justify-center max-nine:tw-px-6 max-nine:tw-text-sm"
            >
              {tMainbanner('discovermorebtn')}
            </PrimaryButtonLink>
          </div>
        </div>
      </div>
      <Image
        src={
          'https://spiritory2storage.blob.core.windows.net/assets/images/banners/macallaneblog.jpg'
        }
        priority={true}
        alt="Bowmore Selection"
        className="tw-absolute tw-inset-0 -tw-z-10 tw-h-full tw-w-full tw-rounded-[30px] tw-object-cover"
        width={1250} // Geben Sie hier die tatsächliche Breite des Bildes an
        height={390}
      />
    </div>
  );
}

export function WinDalmore() {
  const { t: tMainbanner } = useTranslation('mainbanner');
  return (
    <div className="col-12 tw-relative tw-flex tw-h-[390px] tw-items-center tw-justify-center tw-rounded-[30px] max-nine:tw-h-[320px] max-nine:tw-rounded-none">
      <div className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-between max-nine:tw-justify-center max-nine:tw-px-4 max-nine:tw-backdrop-blur-sm max-md:tw-backdrop-brightness-50">
        <div className="tw-mr-auto tw-flex tw-w-[60%] tw-flex-col tw-gap-4 tw-pl-[80px] tw-pr-24 tw-pt-[10px] max-nine:tw-z-10 max-nine:tw-mr-0 max-nine:tw-items-center max-nine:tw-pl-4 max-nine:tw-pr-4 max-nine:tw-text-center max-md:tw-w-full">
          <h2 className="tw-m-0 tw-flex tw-flex-col tw-border-4 tw-border-l-0 tw-border-r-0 tw-border-t-0 tw-border-solid tw-border-custom-gold tw-pb-4 tw-font-prata tw-text-4xl tw-leading-[60px] tw-text-white max-xl:tw-text-4xl max-nine:tw-relative max-nine:tw-border-b-0 max-nine:tw-text-center max-nine:tw-text-2xl max-nine:tw-leading-[1.2] max-nine:tw-text-white">
            {tMainbanner('windalmoreh1')}
            <hr
              className="tw-hidden max-nine:tw-absolute max-nine:tw-bottom-0 max-nine:tw-m-0 max-nine:tw-block max-nine:tw-h-1 max-nine:tw-w-full max-nine:tw-rounded-full max-nine:tw-border-t-0 max-nine:tw-border-none max-nine:tw-bg-custom-gold max-nine:tw-p-0 max-nine:tw-opacity-100"
              aria-hidden="true"
            />
          </h2>
          <div>
            <div className={'tw-flex tw-flex-col tw-justify-center tw-font-light'}>
              <p className="pt-2 tw-mb-0 tw-font-normal tw-text-white max-nine:tw-text-center max-nine:!tw-text-sm">
                {tMainbanner('windalmoretext1')}
                <br></br>
                {tMainbanner('windalmoretext2')}
              </p>
            </div>
          </div>
          <div className="tw-flex tw-items-center tw-justify-start tw-gap-4 child:tw-min-w-32 child:tw-flex-grow max-nine:tw-w-full max-nine:tw-flex-col">
            <PrimaryButtonLink
              href={'/auth/sign-up'}
              className="tw-w-[50%] tw-text-white max-nine:tw-mx-auto max-nine:tw-w-full max-nine:tw-max-w-44 max-nine:tw-px-6 max-nine:tw-text-sm"
            >
              {tMainbanner('signupbtn')}
            </PrimaryButtonLink>
          </div>
        </div>
      </div>

      <Image
        src={
          'https://spiritory2storage.blob.core.windows.net/assets/images/banners/windalmore.webp'
        }
        priority={true}
        alt="main banner background image"
        className="tw-absolute tw-right-0 tw-top-0 tw--z-10 tw-h-full tw-w-full tw-rounded-[30px] tw-object-cover tw-object-center max-nine:tw-rounded-none"
        width={1250} // Geben Sie hier die tatsächliche Breite des Bildes an
        height={390}
      />
    </div>
  );
}
